import Vue from "vue";
import VueRouter from "vue-router";
import { authority } from "../shared/security/authority";
import Error from "../views/Error.vue";

import accountRoutes from "./account";
import payrollsRoutes from "./payroll";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Start",
    component: () => import("../views/StartPage.vue")
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue")
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("../views/Home.vue"),
    meta: {
      authorities: [
        authority.ADMIN.role,
        authority.EMPLOYEE.role,
        authority.COMPANY.role,
        authority.CONSULTANT.role,
      ]
    }
  },
  {
    path: "/forbidden",
    name: "Forbidden",
    component: Error,
    meta: { error403: true }
  },
  {
    path: "/not-found",
    name: "NotFound",
    component: Error,
    meta: { error404: true }
  },
  ...accountRoutes,
  ...payrollsRoutes,
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
